import { LANGUAGES } from "../lib/api";
import { Badge } from "./ui/badge";

export default function LanguagePicker({ label, selected = [], onChange, color = "primary", testid }) {
  const toggle = (lang) => {
    if (selected.includes(lang)) onChange(selected.filter((l) => l !== lang));
    else onChange([...selected, lang]);
  };
  return (
    <div data-testid={testid}>
      <p className="text-xs tracking-[0.15em] uppercase font-bold text-muted-foreground mb-2">{label}</p>
      <div className="flex flex-wrap gap-2">
        {LANGUAGES.map((lang) => {
          const on = selected.includes(lang);
          const cls = on
            ? color === "secondary"
              ? "bg-secondary text-secondary-foreground border-secondary"
              : "bg-primary text-primary-foreground border-primary"
            : "bg-transparent text-foreground/70 border-border hover:border-primary/40";
          return (
            <button type="button" key={lang} onClick={() => toggle(lang)}
              data-testid={`${testid}-${lang.toLowerCase()}`}
              className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-all ${cls}`}>
              {lang}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function LangBadges({ langs = [], variant = "primary" }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {langs.map((l) => (
        <Badge key={l} className={variant === "secondary" ? "bg-secondary/15 text-secondary hover:bg-secondary/15 border-0" : "bg-primary/15 text-primary hover:bg-primary/15 border-0"}>
          {l}
        </Badge>
      ))}
    </div>
  );
}
